import './AutoMessageForm.scss'
import React from 'react'
import { CreateForm, TextArea, TextInput, Select, Button, SubmitButton } from '../../lib'
import { TRIGGER_TYPES, MATCH_TYPES } from '../../app/constants'

const schema = {
  type: {
    required: true,
    defaultValue: TRIGGER_TYPES.TIME_ON_PAGE,
    options: [
      { value: TRIGGER_TYPES.TIME_ON_PAGE, label: 'Time on current page (seconds)' },
      { value: TRIGGER_TYPES.PAGE_VIEWS, label: 'Number of page views' },
      { value: TRIGGER_TYPES.MATCH_URL, label: 'Current page url' }
    ]
  },
  message: {
    label: 'Message',
    required: true
  },
  wait: {
    label: 'Show this message after',
    type: 'number',
    required: true,
    defaultValue: 30
  },
  match: {
    defaultValue: 1,
    options: [
      { value: MATCH_TYPES.INCLUDES, label: 'Includes' },
      { value: MATCH_TYPES.STARTS_WITH, label: 'Starts with' },
      { value: MATCH_TYPES.EXACTLY, label: 'Is exactly' }
    ]
  },
  path: {
    type: 'text',
    placeholder: '/pricing'
  },
  views: {
    type: 'number',
    placeholder: 3
  }
}

const AutoMessageForm = ({ fieldsData, handleSubmit, onClose, prompt, ...rest }) => {
  const isType = (type) => type === parseInt(fieldsData.type.value, 10)
  return (
    <form className='AutoMessageForm' onSubmit={handleSubmit}>
      <div className='AutoMessageForm_rule'>
        <span>When</span>
        <Select {...fieldsData.type} inline />
        {isType(TRIGGER_TYPES.MATCH_URL)
          ? <Select {...fieldsData.match} inline />
          : <span>is</span>
        }
        {isType(TRIGGER_TYPES.TIME_ON_PAGE) &&
          <TextInput {...fieldsData.wait} inline />
        }
        {isType(TRIGGER_TYPES.PAGE_VIEWS) &&
          <TextInput {...fieldsData.views} inline />
        }
        {isType(TRIGGER_TYPES.MATCH_URL) &&
          <TextInput {...fieldsData.path} inline />
        }
      </div>
      <TextArea {...fieldsData.message} />
      {!isType(TRIGGER_TYPES.TIME_ON_PAGE) &&
        <div className='AutoMessageForm_wait'>
          <TextInput {...fieldsData.wait} /> seconds
        </div>
      }
      <footer>
        <SubmitButton {...rest}>
          {prompt}
        </SubmitButton>
        <Button styleType='text' onClick={onClose}>
          Cancel
        </Button>
      </footer>
    </form>
  )
}

AutoMessageForm.displayName = 'AutoMessageForm'

export default CreateForm(AutoMessageForm, schema)



// WEBPACK FOOTER //
// ./src/channel/automessages/AutoMessageForm.js